import { useQuery } from '@tanstack/vue-query';
import { Ref, ref, watch } from 'vue';

import personApi from '~/services/person-api/person-api';
import { wait } from '~/utils/promises';

import { queryKeys } from '../queryClient';

export default function useUsers(id: Ref<string>, clearCache: Ref<boolean> = ref(false)) {
  const queryKey = ref(queryKeys.USERS.DETAILS(id.value));

  const queryFn = async () => {
    const [person] = await Promise.all([
      personApi.user.getById(id.value, {
        clear_cache: clearCache.value,
      }),
    ]);

    return {
      person,
    };
  };

  const query = useQuery({
    queryFn,
    queryKey,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  watch([id, clearCache], async ([newId]) => {
    queryKey.value = queryKeys.USERS.DETAILS(newId);
    await wait(300);
    query.refetch();
  }, { immediate: true });

  return query;
}
